import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import "../Styles/SubPillarsPage.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import NavBar from "../NavBar";
import Footer from "../Footer";
// import Footer from "../Footer";

// Import local images
import esports1 from "../../Assets/gamingimages01.jpg";
import esports2 from "../../Assets/esports2.jpeg";
import esports3 from "../../Assets/esports3.jpeg";

import web3 from "../../Assets/web3.webp";
import web2 from "../../Assets/robotics.jpg";
import web1 from "../../Assets/web1.jpeg";

import design1 from "../../Assets/design1.jpeg";
import design2 from "../../Assets/design2.jpeg";
import design3 from "../../Assets/design3.jpeg";

import entrepreneur1 from "../../Assets/gallery1.jpeg";
import entrepreneur2 from "../../Assets/gallery2.jpeg";
import entrepreneur3 from "../../Assets/gallery3.jpeg";

const subPillars = [
  {
    name: "E-Sports",
    description: "Compete and excel in various gaming tournaments.",
    images: [esports1, esports2, esports3],
  },
  {
    name: "Professional Development (Web Development & IoT)",
    description: "Learn web development, IoT, and enhance your tech skills.",
    images: [web3, web2, web1],
  },
  {
    name: "Graphic Design",
    description: "Unleash your creativity with modern design tools.",
    images: [design1, design2, design3],
  },
];

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  arrows: true,
};

const SubPillarsPage = () => {
  const navigate = useNavigate();

  const handleJoin = (name) => {
    navigate(`/join/${encodeURIComponent(name)}`);
  };

  const handleView = (name) => {
    navigate(`/view/${encodeURIComponent(name)}`);
  };

  return (
    <div className="subpillars-container">
      <NavBar />
      <br></br>
      <h1 className="title">Techstrike Club Sub-Pillars</h1>
      <br />
      <div className="cards-container">
        {subPillars.map((pillar, index) => (
          <motion.div
            className="pillar-card"
            key={index}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.3 }}
            whileHover={{ scale: 1.07, boxShadow: "0px 20px 40px rgba(0,0,0,0.4)" }}
          >
            <motion.div whileHover={{ scale: 1.03 }} className="pillar-slider">
              <Slider {...sliderSettings}>
                {pillar.images.map((img, idx) => (
                  <img key={idx} src={img} alt={`${pillar.name} ${idx}`} className="pillar-image" />
                ))}
              </Slider>
            </motion.div>
            <h2>{pillar.name}</h2>
            <p>{pillar.description}</p>
            <div className="buttons">
              <motion.button
                whileHover={{ scale: 1.1 }}
                className="join-btn"
                onClick={() => handleJoin(pillar.name)}
              >
                Join
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.1 }}
                className="view-btn"
                onClick={() => handleView(pillar.name)}
              >
                View
              </motion.button>
            </div>
          </motion.div>
        ))}
      </div>
      <br></br><br></br><br></br>

    </div>

  );
};

export default SubPillarsPage;
